const requirePublicUrl = (name) => {
  const value = process.env[name];
  if (!value) throw new Error(`Configurazione Iubenda mancante: ${name}`);
  return value;
};

export const IUBENDA_PRIVACY_URL = requirePublicUrl("REACT_APP_IUBENDA_PRIVACY_URL");
export const IUBENDA_COOKIE_URL = requirePublicUrl("REACT_APP_IUBENDA_COOKIE_URL");

export const openIubendaPreferences = (event) => {
  event?.preventDefault?.();
  const ui = window._iub?.cs?.api?.ui;
  if (typeof ui?.openPreferences === "function") ui.openPreferences();
};